// src/App.tsx
import { HelmetProvider } from 'react-helmet-async';
import { RouterProvider } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import './App.css';
import { I18nProvider } from './i18n';
import { router } from './routes';

export default function App() {
  return (
    <RecoilRoot>
      <I18nProvider>
        <HelmetProvider>
          <RouterProvider router={router} />
        </HelmetProvider>
      </I18nProvider>
    </RecoilRoot>
  );
}
